import getIcon from './utils/getIcon';
const icon = getIcon("Lock", "10.4.2");
export default icon;
//# sourceMappingURL=Lock.js.map